'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createFactory = require('./create-factory');

var _createFactory2 = _interopRequireDefault(_createFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * expose class creation function
 */

exports['default'] = (0, _createFactory2['default'])(Object);


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/utils/class/create.js
 ** module id = 506
 ** module chunks = 0 1
 **/